import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { PulseLoader } from 'react-spinners';
import LoadingOverlay from 'react-loading-overlay';
import MyPageAlert from '../../../../../common/components/MyPageAlert';
import { ErrorIcon } from '../../../../../common/icons';
import WhereIsIdAdesioneModal from '../WhereIsIdAdesioneModal';
import MoveInAppWarning from '../../../../../common/components/MoveInAppWarning';
import { InfoIcon } from '../../../../../common/icons/redesignIcons';

import './WelcomeHero.css';

const CardIcon = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="var(--teal-d)" strokeWidth="2" style={{ flex: 'none' }}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M7 9h4M7 13h10" />
  </svg>
);

@inject('translationsStore', 'moveinStore')
@observer
class WelcomeHero extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisibleWhereIsIdAdesioneModal: false
    };
  }

  handleEnter = e => {
    if (e.key === 'Enter') {
      this.props.onIdAdesioneSubmit();
    }
  };

  render() {
    const { translationsStore, moveinStore } = this.props;
    const { isVisibleWhereIsIdAdesioneModal } = this.state;

    return (
      <div className="WelcomeHero mv-hero-bg">
        <div className="mv-badge">
          <span className="mv-badge-dot" />
          {translationsStore.translate('movein.stepWelcome.hero.badge')}
        </div>
        <h1 className="mv-h1">{translationsStore.translate('movein.stepWelcome.labelWelcomeIntro')}</h1>
        <p className="mv-lead">{translationsStore.translate('movein.stepWelcome.hero.subtitle')}</p>
        <LoadingOverlay
          active={moveinStore.loadingCheckIdAdesione}
          spinner={<PulseLoader sizeUnit={'px'} size={10} color={'var(--action-primary-color)'} loading={true} />}
          styles={{
            overlay: base => ({
              ...base,
              background: 'var(--grey-light-color-50)'
            })
          }}
        >
          <div className="WelcomeHeroForm">
            <div className="WelcomeHeroInput">
              <CardIcon />
              <input
                type="text"
                placeholder={translationsStore.translate('movein.stepWelcome.labelWelcomeHint')}
                value={moveinStore.draftIdAdesione}
                onChange={e => {
                  moveinStore.setDraftIdAdesione(e.target.value);
                }}
                onKeyUp={this.handleEnter}
              />
            </div>
            <button
              className="mv-btn WelcomeHeroSubmit"
              disabled={moveinStore.draftIdAdesione === '' || moveinStore.loadingCheckIdAdesione}
              onClick={this.props.onIdAdesioneSubmit}
            >
              {translationsStore.translate('movein.stepWelcome.labelWelcomeSubmit')}
            </button>
          </div>
        </LoadingOverlay>
        <div className="WhereIsIdAdesioneLink" onClick={() => this.setState({ isVisibleWhereIsIdAdesioneModal: true })}>
          <InfoIcon />
          {translationsStore.translate('movein.stepWelcome.whereIsIdAdesione')}
        </div>
        <WhereIsIdAdesioneModal visible={isVisibleWhereIsIdAdesioneModal} onCancel={() => this.setState({ isVisibleWhereIsIdAdesioneModal: false })} />
        {moveinStore.lastError !== null && (
          <MyPageAlert
            className="WelcomeHeroError"
            style={{ marginTop: 16, maxWidth: 560, marginLeft: 'auto', marginRight: 'auto', textAlign: 'left' }}
            message={translationsStore.translate('movein.stepWelcome.errorIdAdesioneInput')}
            description={translationsStore.translate('movein.stepWelcome.errorIdAdesioneInputDescription')}
            type="error"
            closable
            showIcon
            icon={<ErrorIcon width={20} height={20} />}
          />
        )}
        <div className="WelcomeHeroWarn">
          <MoveInAppWarning />
        </div>
      </div>
    );
  }
}

export default WelcomeHero;
